import { getStore } from '../store/tabStore';
import TabViewState, { TabState } from '../store/schema/TabViewState';

export default function getPopoutTabsViewState(): TabViewState[] {
    return getStore().tabs.filter(viewState => viewState.state === TabState.Popout);
}
